
import { Component, inject } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Loader, UnsubscriberClass } from '@aston/foundation';
import { TranslateModule } from '@ngx-translate/core';

import { AuthenticationService } from '../../services';

@Component({
	selector: 'authentication-issue-page',
	templateUrl: './authentication-issue-page.component.html',
	imports: [TranslateModule]
})
export class AuthenticationIssuePageComponent extends UnsubscriberClass {
	protected authenticationService = inject(AuthenticationService);
	protected activatedRoute = inject(ActivatedRoute);
	protected router = inject(Router);


	formLoader = new Loader();
	redirectAlreadyDone: boolean;
}
